import React, { useMemo, useState } from "react";
import ProviderViewAvailability from "./ProviderViewAvailability";
import ProviderViewAppointments from "./ProviderViewAppointments";
import ProviderViewSettings from "./ProviderViewSettings";
import ConsultantManagementTab from "./ConsultantManagementTab";
import AppointmentSecondaryTabs from "./AppointmentSecondaryTabs";
import checkPermission from "../../../utils/permission";
import { useAuth } from "../../../contexts/AuthContext";

export default function ProviderTabs() {
  const { user } = useAuth();
  const isSuperAdmin = !!(user as any)?.isSuperAdmin;

  const [activeTab, setActiveTab] = useState<"create" | "requests" | "settings" | "consultants">("requests");

  const canManage = checkPermission("appointment_manage");
  const canList = checkPermission("appointment_list");
  const canUpdate = checkPermission("appointment_update");

  const availableTabs = useMemo(() => {
    return [
      { id: "requests", label: "Randevu Talepleri", visible: canList },
      { id: "create", label: "Müsaitlik Takvimi", visible: canManage },
      { id: "settings", label: "Randevu Ayarları", visible: canUpdate },
      { id: "consultants", label: "Danışman Yönetimi", visible: isSuperAdmin },
    ] as const;
  }, [canManage, canList, canUpdate, isSuperAdmin]);

  const firstVisible = availableTabs.find((t) => t.visible)?.id || "requests";
  const currentTab = availableTabs.find((t) => t.id === activeTab && t.visible) ? activeTab : firstVisible;

  const subTabs = availableTabs.filter((t) => t.visible).map((t) => ({ id: t.id, label: t.label }));

  return (
    <div className="relative mr-0 flex h-full min-h-0 w-full flex-col bg-gray-50 sm:mr-1 sm:rounded-lg sm:shadow-sm">
      <div className="flex-shrink-0 px-3 pt-4 sm:px-6 sm:pt-6">
        <AppointmentSecondaryTabs
          eyebrow="Randevu Yönetimi"
          tabs={subTabs}
          activeId={currentTab}
          onChange={(id) => setActiveTab(id as "create" | "requests" | "settings" | "consultants")}
        />
      </div>
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        {currentTab === "requests" ? (
          <ProviderViewAppointments />
        ) : (
          <div className="min-h-0 flex-1 overflow-y-auto">
            {currentTab === "create" ? (
              <ProviderViewAvailability />
            ) : currentTab === "consultants" ? (
              <ConsultantManagementTab />
            ) : (
              <ProviderViewSettings />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
